import React from 'react';
import PropTypes from 'prop-types';
import List from '@material-ui/core/List';
import VerticalNavLink from '../verticalNavLink';

function FGWListOverview({ handleDrawerToggle, onActive }) {
    return (
        <List disablePadding>
            <VerticalNavLink
                onActive={onActive}
                to={'/flight/gateway/general/flight-gateway-overview'}
                onClick={handleDrawerToggle}
                secondary={'Overview'}
            />

            <VerticalNavLink
                onActive={onActive}
                to={'/flight/gateway/general/flight-gateway-system-requirements'}
                onClick={handleDrawerToggle}
                secondary={'System Requirements'}
            />

            <VerticalNavLink
                onActive={onActive}
                to={'/flight/gateway/general/flight-gateway-downloads'}
                onClick={handleDrawerToggle}
                secondary={'Download Flight Gateway'}
            />

            <VerticalNavLink
                onActive={onActive}
                to={'/flight/gateway/general/integrating-manager-agents'}
                onClick={handleDrawerToggle}
                secondary={'Integrating Manager+Agents'}
            />
            <VerticalNavLink
                onActive={onActive}
                to={'/flight/gateway/general/region-reference'}
                onClick={handleDrawerToggle}
                secondary={'Region Reference'}
            />
        </List>
    );
}

FGWListOverview.propTypes = {
    onActive: PropTypes.func,
    handleDrawerToggle: PropTypes.func,
};

export default FGWListOverview;
